<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      Claim Voucher
    </h6>

    <form id="form-proper">
        <div class="row">
          <div class="col">
            <base-input label="Membership Number" required>
              <a-input v-model="$v.formData.membership_number.$model"/>
              <div v-if="$v.formData.membership_number.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.membership_number.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Voucher Code" required>
              <a-input v-model="$v.formData.voucher_code.$model"/>
              <div v-if="$v.formData.voucher_code.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.voucher_code.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>
      <div
        style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;"
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer()"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="validated === true"
                    size="sm"
                    variant="primary"
                    @click.prevent="claimVoucher"
                  >
                    Claim
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="validateVoucher"
                  >
                    Validate
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div v-if="validated">
      <h1>Voucher Details</h1>
      <div>
        <div class="row">
          <div class="col">
            <base-input label="Voucher Type">
              <a-input v-model="voucher_detail.type" :disabled="viewMode" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Voucher Code">
              <a-input v-model="voucher_detail.code" :disabled="viewMode" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Voucher name">
              <a-input v-model="voucher_detail.name" :disabled="viewMode" />
            </base-input>
          </div>
        </div>
        <div class="row" v-if="voucher_detail.eligibility != null">
          <div class="col">
            <base-input label="Voucher Eligibility">
              <a-textarea
                    placeholder="Voucher Eligibility"
                    :rows="2"
                    v-model="voucher_detail.eligibility"
                    :disabled="viewMode"
                  />
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Voucher Reward">
              <a-textarea
                    placeholder="Voucher Reward"
                    :rows="2"
                    v-model="voucher_detail.reward"
                    :disabled="viewMode"
                  />
            </base-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import HTTPRequest from '../../controllers/httpRequest';

export default {
  name: 'ClaimVoucherForm',
  props: {
    drawerVisible: Boolean
  },
  data() {
    return {
      viewMode: true,
      validated: false,
      formSubmitting: false,
      formDataUpdated: false,
      current_voucher_code: null,
      current_membership_number: null,
      voucher_detail: {
        type: null,
        code: null,
        name: null,
        duration: null,
        eligibility: null,
        reward: null
      },
      formData: {
        voucher_code: null,
        membership_number: null,
      }
    };
  },

  validations () {
    let validation = {
      formData: {
        voucher_code: { required },
        membership_number: { required },
      }
    }
    return validation;
  },

  methods: {
    async validateVoucher() {
      this.$v.formData.$touch();
      if(!this.$v.formData.$invalid) {
        const response = await HTTPRequest.postRequest('/api/v1/vouchers/validate', {
          claim_detail: this.formData
        });
        if (response.id) {
          this.voucher_detail = response;
          this.voucher_detail.type= response.voucherType.name;
          this.voucher_detail.code= response.code;
          this.voucher_detail.name= response.name;
          this.voucher_detail.duration= `${response.start_date} - ${response.end_date}`;
          this.voucher_detail.reward= JSON.stringify(response.voucher_rewards)
          if(typeof response.voucher_listing_conditions.membership_program != 'undefined') {
            this.voucher_detail.eligibility = JSON.stringify(
              {'membership_program': response.voucher_listing_conditions.membership_program.name}
            );
          }
          this.validated = true;
          this.current_voucher_code = this.formData.voucher_code;
          this.current_membership_number = this.formData.membership_number;
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }
      }
    },
    async claimVoucher() {
      this.$v.formData.$touch();
      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.postRequest('/api/v1/vouchers/claim', {
          claim_detail: this.formData,
        });

        if (response.status == 'success') {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Claiming has been successful.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },
    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
    },
    clearForm() {
      
      this.formData.voucher_code = null;
      this.formData.membership_number = null;
      this.validated =  false;
      this.formSubmitting =  false;
      this.voucher_detail =  {
        type: null,
        code: null,
        name: null,
        duration: null,
        eligibility: null,
        reward: null
      };
    },
  },
  watch: {
    'formData.voucher_code': function (val) {
      if (val != this.current_voucher_code) {
        this.validated = false;
      }
    },
    'formData.membership_number': function (val) {
      if (val != this.current_membership_number) {
        this.validated = false;
      }
    }
  }
};
</script>

<style scoped></style>
